import React, { useState } from 'react';
import { SearchIcon } from 'lucide-react';
import { usePageMeta, canonicalUrl } from '../hooks/usePageMeta';
import { Eyebrow } from '../components/ui/Eyebrow';
import { PartnerDirectory } from '../components/partners/PartnerDirectory';
import { PartnerApplicationSection } from '../components/partners/PartnerApplicationSection';
export function Partners() {
  const [query, setQuery] = useState('');
  usePageMeta({
    title: 'Partner Marketplace: AI, IP & Diligence Tools | StartupFuel',
    description: 'Discover specialized AI tools, data platforms and expert services for founders, investors and innovation teams — and vote for the partners you want to see across StartupFuel and DiligenceGPT™.',
    path: '/partners',
    keywords: ['startup partner marketplace', 'AI tools for investors', 'due diligence tools', 'patent intelligence'],
    jsonLd: [{
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: canonicalUrl('/')
      }, {
        '@type': 'ListItem',
        position: 2,
        name: 'Partners',
        item: canonicalUrl('/partners')
      }]
    }]
  });
  return <main id="main" className="bg-ink" data-id="element-1952" data-mp="lsyqbejf6zfu">
      <section aria-labelledby="partners-heading" className="relative overflow-hidden border-b border-hairline-soft" data-id="element-1953" data-mp="lu02xng33tzo">
        <div className="sf-grid-texture sf-fade-mask pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-1954" data-mp="hsy2526ir9vl" />
        <div className="relative mx-auto flex w-full max-w-[1320px] flex-col items-center px-4 pb-14 pt-14 text-center sm:px-6 lg:px-8 lg:pb-16 lg:pt-20" data-id="element-1955" data-mp="1ejqfvt5zcpu7">
          <Eyebrow data-id="element-1956" data-mp="14r1ang10w87b">The StartupFuel Partner Ecosystem</Eyebrow>
          <h1 id="partners-heading" className="mt-5 max-w-4xl text-balance text-[38px] font-semibold leading-[1.02] tracking-[-0.04em] text-text-primary sm:text-[54px] lg:text-[62px]" data-id="element-1957" data-mp="10q7k0ew74faq">
            Better Intelligence. Better Decisions. Better Partners.
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-text-secondary sm:text-lg" data-id="element-1958" data-mp="1sg3y54ic8v9q">
            Discover specialized AI tools, data platforms, and expert services that help founders, investors, and innovation teams evaluate opportunities, reduce risk, and make better decisions.
          </p>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-text-tertiary sm:text-[15px]" data-id="element-1959" data-mp="3cz63xifgd8pk">
            Explore our curated ecosystem of partners, discover new capabilities, and vote for the solutions you want to see integrated into StartupFuel and DiligenceGPT™.
          </p>

          <form role="search" onSubmit={event => event.preventDefault()} className="mt-8 w-full max-w-xl" data-id="element-1960" data-mp="38zfepj5kr0n5">
            <label htmlFor="partner-search" className="sr-only" data-id="element-1961" data-mp="2u2ekn8zwutli">
              Search partners
            </label>
            <div className="relative" data-id="element-1962" data-mp="2z1hs103d5bwn">
              <SearchIcon className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-text-tertiary" aria-hidden="true" data-id="element-1963" data-mp="s8ywcirapqtp" />
              <input id="partner-search" type="search" value={query} onChange={event => setQuery(event.target.value)} placeholder="Search partners, solutions, or capabilities..." className="min-h-[52px] w-full rounded-xl border border-hairline bg-panel pl-11 pr-4 text-[15px] text-text-primary shadow-sm placeholder:text-text-tertiary focus:border-lime focus:outline-none focus:ring-2 focus:ring-lime/30" data-id="element-1964" data-mp="x67e4i8j7suf" />
            </div>
          </form>
        </div>
      </section>

      <PartnerDirectory query={query} onQueryChange={setQuery} data-id="element-1965" data-mp="2wep4fuel3fhi" />
      <PartnerApplicationSection data-id="element-1966" data-mp="3af9pkx7z1ne6" />
    </main>;
}